const istarshine = {
  en: {
    istarshine: {
      boolean_query: "Istarshine Search",
      common_boolean_query: "Common Query",
      handles: "Istarshine Handles",
      profile_urls: "Profile URLs",
      handles_add: "Press enter to add handle",
      profile_urls_add: "Press enter to add profile URL",
      config_title: "Search Configuration",
      empty_field: "Not set",
      config_fields: "Configuration Fields",
      instructions: "At least one field (Istarshine Search or Istarshine Handles) must be provided.",
      save_error: "Error saving configuration",
      save_success: "Update successfully",
      query_type: "Query Type",
      query_type_all: "One query for all providers",
      query_type_per_provider: "Per provider queries",
      weibo: "Weibo",
      douyin: "Douyin",
      red: "Red",
      wechat: "WeChat",
      toutiao: "Toutiao",
      wechat_mention: "WeChat",
      douyin_mention: "Douyin",
      red_mention: "Red",
      weibo_mention: "Weibo",
      toutiao_mention: "Toutiao",
      provider_query: "Enter the query for the provider",
      queries_count: "({count})",
      provider_profiles: "Profile URLs",
      providers_section: "Providers",
      validation: {
        at_least_one_required: "At least one field (Istarshine Search or Istarshine Handles) must be provided.",
        query_required: "Query is required and must be a non-empty string.",
        query_max_length: "Query must be 100 characters or fewer."
      },
      confirm_switch_title: "Change Query Type",
      confirm_switch_to_common: "Switching to one query for all providers will delete all per-provider queries. Continue?",
      confirm_switch_to_per_provider: "Switching to per-provider queries will delete the common query. Continue?",
      add_query: "Add OR query",
      remove_query: "Remove query",
      query_number: "Query #{number}",
      filters_section: "Filters for this query",
      delete_saved_search: "Delete",
      delete_all: "Delete All",
      delete_success: "Search configuration removed",
      delete_error: "Could not delete the search configuration",
      confirm_delete_common_title: "Delete common query",
      confirm_delete_common_message: "This removes the saved query used for all providers. You can add a new one later. Continue?",
      confirm_delete_provider_title: "Delete provider query",
      confirm_delete_provider_message: "This removes the saved query for {provider}. Continue?",
      user_filter: "User Filter",
      exclude_mode: "Exclude Users",
      include_mode: "Include Users",
      excluded_users: "Excluded profiles",
      excluded_users_placeholder: "Paste and press Enter to add profile",
      excluded_users_tag_placeholder: "Press Enter to add profile",
      excluded_users_hint_common: "Profile links for users whose data should not be fetched for this common search (max 50).",
      excluded_users_hint_provider: "Profile links to exclude for this provider search (max 50).",
      included_users: "Included profiles",
      included_users_placeholder: "Paste and press Enter to add profile",
      included_users_tag_placeholder: "Press Enter to add profile",
      included_users_hint_common: "Profile links for users whose data should be fetched for this common search (max 50). Only these profiles will be included.",
      included_users_hint_provider: "Profile links to include for this provider search (max 50). Only these profiles will be included.",
      follower_count_filter: "Follower Count Filter",
      follower_count_filter_hint: "Filter users by follower count. Select an operator first, then enter the appropriate value(s).",
      follower_min: "Min",
      follower_max: "Max",
      follower_operator: "Operator",
      follower_min_placeholder: "Minimum followers",
      follower_max_placeholder: "Maximum followers",
      follower_operator_none: "Select operator",
      follower_operator_lt: "< (Less than)",
      follower_operator_lte: "<= (Less than or equal)",
      follower_operator_gt: "> (Greater than)",
      follower_operator_gte: ">= (Greater than or equal)",
      follower_operator_between: ">< (Between)",

      backsearch: {
        title: "Backsearch Requests",
        back_to_config: "Back to Configuration",
        new_request: "New Backsearch Request",
        edit_request: "Edit Backsearch Request",
        request_details: "Request",
        name: "Name",
        name_placeholder: "Enter a name for this backsearch request",
        description: "Description",
        description_placeholder: "Optional description",
        filters: "Filters",
        
        query_section: "Query",
        query: "Search Query",
        query_placeholder: "Enter search query (max 100 characters)",
        max_post_count: "Max Post Count",
        max_post_count_hint: "Maximum number of posts to retrieve (1 – 5,000)",
        providers: "Providers",
        providers_hint: "Select providers or leave empty for all providers",
        all_providers: "All Providers",
        exclude_users: "Exclude Users (Blacklist)",
        exclude_filter: "Exclude Users (Blacklist)",
        excluded_users: "Excluded Users",
        excluded_users_placeholder: "Type username and press Enter",
        excluded_users_tag_placeholder: "Press Enter to add username",
        excluded_users_hint: "Posts from these users will be excluded (max 50)",
        include_users: "Include Users (Whitelist)",
        include_filter: "Include Users (Whitelist)",
        included_users: "Included Users",
        included_users_placeholder: "Type username and press Enter",
        included_users_tag_placeholder: "Press Enter to add username",
        included_users_hint: "Only posts from these users will be included (max 50)",
        follower_count_filter: "Follower Count Filter",
        follower_operator: "Operator",
        follower_min: "Minimum Followers",
        follower_max: "Maximum Followers",
        no_follower_filter: "No follower filter",
        follower_filter_hint: "Filter posts by author's follower count",
        start_date: "Start Date",
        start_date_hint: "Start date cannot be more than one year in the past.",
        end_date: "End Date",
        date_hint: "End date must be after the start date.",
        status: "Status",
        status_null: "Draft",
        status_queued: "Queued",
        status_processing: "Processing",
        status_completed: "Completed",
        status_errored: "Errored",
        actions: "Actions",
        save: "Save",
        deploy: "Deploy",
        confirm_deploy_title: "Confirm Deploy",
        confirm_deploy_message: "Once deployed, this request cannot be edited or re-deployed. Continue?",
        delete: "Delete",
        confirm_delete_title: "Delete Backsearch Request",
        confirm_delete_message: "Are you sure you want to delete this backsearch request?",
        edit: "Edit",
        copy_from_label: "Copy settings from",
        copy_from_placeholder: "Select a search or backsearch",
        copy_from_group_config: "Search configuration",
        copy_from_group_backsearch: "Previous backsearches",
        no_searches: "No searches available",
        cancel: "Cancel",
        search_placeholder: "Search requests…",
        no_requests: "No backsearch requests yet.",
        create_first: "Create your first backsearch request to pull historical data.",
        save_success: "Backsearch request saved successfully",
        save_error: "Error saving backsearch request",
        deploy_success: "Backsearch request deployed to queue",
        deploy_error: "Error deploying backsearch request",
        delete_success: "Backsearch request deleted",
        delete_error: "Error deleting backsearch request",
        volume_remaining: "iStarShine Backsearch Remaining",
        volume_processed: "processed",
        volume_limit: "limit",
        quota_exceeded: "Requested volume exceeds remaining backsearch quota",
        quota_reached: "Backsearch quota has been reached. No further requests can be deployed.",
        quota_loading: "Loading quota",
        quota_load_error: "Backsearch quota could not be loaded. Try refreshing the page.",
        received_posts: "Received Posts",
        created: "Created",
        created_on: "Created on {date}",
        completed_on: "Completed on {date}",
        errors_label: "Errors",
        validation: {
          name_required: "Name is required",
          name_max_length: "Name must be 255 characters or fewer",
          description_max_length: "Description must be 2,000 characters or fewer",
          query_required: "Query is required",
          query_max_length: "Query must be 100 characters or fewer",
          max_post_count_required: "Max post count is required",
          max_post_count_range: "Max post count must be between 1 and 5,000",
          start_date_required: "Start date is required",
          end_date_required: "End date is required",
          start_before_end: "Start date must be before end date",
          date_not_future: "Date cannot be in the future",
          excluded_users_max: "Maximum 50 excluded users allowed",
          included_users_max: "Maximum 50 included users allowed",
          follower_min_required: "Minimum follower count is required",
          follower_max_required: "Maximum follower count is required",
          follower_min_less_than_max: "Minimum must be less than maximum",
          providers_invalid: "One or more selected providers are invalid"
        }
      }
    }
  }
}

module.exports.istarshine = istarshine;

